import { Link } from 'react-router-dom';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function NotFound() {
  usePageMeta({
    title: '页面不存在 - av免费网站',
    description: '你访问的页面不存在或已被移除，请返回首页继续浏览高清影片分类与最新内容。',
    keywords: 'av免费网站,页面不存在,高清影视',
  });

  return (
    <div className="max-w-page mx-auto px-4 md:px-8 py-20 md:py-28">
      <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_420px] gap-8 items-center">
        <div>
          <p className="text-[11px] tracking-[0.3em] text-secondary-600 font-label uppercase">Error 404</p>
          <p className="mt-4 font-label text-7xl md:text-9xl leading-none text-primary-500/30">404</p>
          <h1 className="mt-2 text-2xl md:text-4xl font-black tracking-tight">这个页面走丢了</h1>
          <p className="mt-4 max-w-lg text-sm md:text-base leading-relaxed text-foreground-700">
            链接可能已经失效，或者页面地址输入有误。与其停在空白页，不如从下面直接进入正在更新的内容。
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to="/"
              className="h-11 px-6 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-medium flex items-center hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/category/latest"
              className="h-11 px-6 rounded-md border border-background-300/70 text-sm text-foreground-800 flex items-center hover:border-primary-500/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              浏览最新影片
            </Link>
            <Link
              to="/search"
              className="h-11 px-6 rounded-md border border-background-300/70 text-sm text-foreground-800 flex items-center hover:border-primary-500/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              搜索影片
            </Link>
          </div>
          <div className="mt-8 flex flex-wrap gap-2">
            {[
              { label: '热门', to: '/category/hot' },
              { label: '经典', to: '/category/classic' },
              { label: '常见问题', to: '/faq' },
              { label: '关于我们', to: '/about' },
            ].map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="h-8 px-3 rounded-full bg-secondary-100 text-secondary-900 text-xs flex items-center hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden border border-background-300/60 bg-background-100">
          <img
            src="https://readdy.ai/api/search-image?query=Cinematic%20empty%20movie%20theater%20hallway%20with%20dim%20amber%20wall%20lights%20and%20a%20closed%20door%2C%20deep%20shadows%2C%20moody%20atmospheric%20photography%2C%20film%20grain%2C%20no%20people%2C%20no%20text&width=800&height=600&seq=av-404-empty-hall&orientation=landscape"
            alt="昏暗的影院走廊与关着的门"
            title="页面不存在 - av免费网站"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/20 to-transparent" />
          <p className="absolute inset-x-0 bottom-0 p-4 text-xs text-foreground-700">配图为站内视觉示意素材</p>
        </div>
      </div>
    </div>
  );
}